/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import PropTypes from "prop-types";
import Dropzone from 'react-dropzone';
import ModalDialog from '../../../../widgets/ModalDialog/ModalDialog';
import {OM3P} from '../../../../constants/constants';
import { TextInput, Select, MultiLineText } from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import urlHelper from "../../../../../_helpers/url.format.server.helper";
import config from "../../../../../config";
import AxiosClient from "../../../../../_helpers/http.helper";
import {AuthConsumer} from "../../../../context/AuthContext";


class Om3pModalContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successObj: {
                title: '',
                firstName: '',
                lastName: '',
                haveRights: true,
                contentType: 'Textbook',
                insertAfter: 0,
                trimSize: '',
                type: 'Original Material(OM)',
                resourceColorSetting: 'Color',
                description: '',
            },

            errorObj: {
                title: null,
                firstName: null,
                lastName: null
            },
            fileName: '',
            uploadStatus: '*PDF Only',
            resourceId: null,
            errorMsg: '',
            showError: false,
        };

        this.updateState = this.updateState.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.upload = this.upload.bind(this);
        this.addButtonClick = this.addButtonClick.bind(this);
    }

    componentDidMount() {

        if(this.props.editModal) {

            const successObj = this.state.successObj;
            let fName = "";
            let lName = "";
            if(this.props.resourceData.authors){
                fName = this.props.resourceData.authors.split(" ")[0];
                lName = this.props.resourceData.authors.split(" ")[1];
            }

            successObj[OM3P.TITLE] = this.props.resourceData.title;
            successObj[OM3P.CONTENT_TYPE] = this.props.resourceData.category;
            successObj[OM3P.FIRST_NAME] = fName;
            successObj[OM3P.LAST_NAME] = lName;
            successObj[OM3P.TYPE] = this.props.resourceData.pearsonResourceType === OM3P.RIGHTS_OM ? OM3P.ORIGINAL_MATERIAL : OM3P.THIRD_PARTY;
            successObj[OM3P.TRIM_SIZE] =this.props.resourceData.trimSize.name;
            successObj[OM3P.COLOR] = this.props.resourceData.resourceColorSetting === OM3P.FOUR_COLOR ? OM3P.FOUR_COLOR : OM3P.BLACK_WHITE;
            successObj[OM3P.DESCRIPTION] = this.props.resourceData.description;

            this.setState({
                successObj: successObj
            });

            if (this.props.resourceId) {
                this.setState({
                    resourceId: this.props.resourceId
                });
            }

            // }


        }
    }

    onDrop = (file) => {
        this.upload(file);
    };

    upload(files) {
        const formData = new FormData();
        formData.append("file", files[0]);
        this.setState({
            fileName: files[0].name,
            uploadStatus: 'Uploading...'
        });

        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.uploadResource,
            {
                queryParams:{
                    orientation: this.props.activeCollection.trimSize.orientation,
                    collectionType: this.props.activeCollection.collectionType,
                    collectionId: this.props.activeCollection.collectionId,
                    unscrubbed: this.props.activeCollection.unscrubbed

                }
            }

        );

        AxiosClient.post(url,formData, { "headers": { "content-type": "multipart/form-data" } })
            .then(response => {
                this.setState({showError: false});
                this.setState({resourceId: response.data.resourceId});
            })
            .catch(error => {
                if(error.response.status === 400){
                    this.setState({showError: true});
                    this.setState({errorMsg: error.response.data.message});
                }

                if(error.response.status === 500){
                    this.setState({errorMsg: ""});
                }
                console.log("Error ", error);
            });
    }

    addButtonClick () {

        const reqBody = {...this.state.successObj};
        reqBody.authors = this.state.successObj.firstName + ' ' + this.state.successObj.lastName;
        reqBody.pearsonResourceType = 'OM';
        reqBody.cccSearchDTO = {};
        reqBody.cccSearchDTO.primaryAuthorName = reqBody.authors;
        reqBody.cccSearchDTO[OM3P.SUB_TITLE] = this.state.successObj[OM3P.TITLE];
        let resourceColorSetting = null;

        if (this.state.successObj.resourceColorSetting === OM3P.FOUR_COLOR) {
            resourceColorSetting = OM3P.FOUR_COLOR;
        } else {
            resourceColorSetting = OM3P.SINGLE_COLOR;
        }
        reqBody.resourceColorSetting = resourceColorSetting;
        delete reqBody[OM3P.TRIM_SIZE];
        delete reqBody[OM3P.TYPE];
        delete reqBody[OM3P.INSERT_AFTER];
        delete reqBody[OM3P.CONTENT_TYPE];
        reqBody.init ={};
        reqBody.init.activeCollection = this.props.activeCollection;
        reqBody.init.collectionTitle = this.props.activeCollection.title;
        reqBody.init.chapterId = this.props.chapterId;
        reqBody.init.currency = this.props.activeCollection.geo.code;
        reqBody.init.insertAfter = (this.state.successObj.insertAfter)-1;
        reqBody.init.priceType = this.props.activeCollection.collectionType;
        reqBody.init.totalPrice = this.props.activeCollection.priceModel.totalPrice;

        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.AddAdditionalInfo,
            {
                resourceId: this.state.resourceId
            }

        );

        AxiosClient.post(url,reqBody)
            .then(response => {

                !this.props.editModal && this.addToCollection();

                if(this.props.editModal) {
                    this.props.loadCollection(this.props.activeCollection.collectionId);
                    this.props.onCancel();
                }
            });


    }

    addToCollection = () =>{

        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.addResourcesToCollection,
            {
                collectionId: this.props.activeCollection.collectionId,
                chapterId: this.props.chapterId
            }
        );

        const payload = {
            resourceIds: [this.state.resourceId],
            insertAfter: this.state.successObj.insertAfter-1
        };

        AxiosClient.defaults.headers.common['X-UserId'] = this.props.userId;

        AxiosClient.post(url,payload)
            .then(response => {
                this.props.loadCollection(this.props.activeCollection.collectionId);
            })
            .catch(error => {
                console.log("Error ", error);
            });

        this.props.onCancel();

    };

    updateState(attribute, value, callBack){
        const successObj = this.state.successObj;
        successObj[attribute] = value;
        this.setState({
            successObj: successObj
        }, callBack);
    }

    handleChange(e){
        this.updateState(e.target.id, e.target.value);
    }

    render() {
        let {successObj} = this.state;
        return <ModalDialog
            showModal={this.props.showModal}
            onSuccess={this.addButtonClick}
            onCancel={this.props.onCancel}
            showError={this.state.showError}
            errorMsg={this.state.errorMsg}
            title="Add Original Material"
            successText = {this.props.editModal ? 'Save' : 'Add'}
            disableSuccess ={this.state.successObj.title === "" || this.state.successObj.resourceId}
        >
            <div className="om-3p-modal-content">

                <div className={successObj.type === OM3P.THIRD_PARTY ? 'om-shrink addOmDiv': 'addOmDiv'}>
                    <div className="pe-form form-partitions">
                        <div>
                            {
                                !this.props.editModal && <div className="child-container">
                                    <TextInput id="fileName" changeHandler={() => {}} labelText="File"
                                        placeholder="File Name" inputState="disabled" value={this.state.fileName}/>
                                </div>
                            }

                            {
                                !this.props.editModal && < div className="child-container">
                                    <Dropzone onDrop={(acceptedFiles) => {this.onDrop(acceptedFiles);}}>
                                        {({getRootProps, getInputProps}) => (
                                            <section className="pdf-choose-section">
                                                <div {...getRootProps()}>
                                                    <input {...getInputProps()} />
                                                    <button className="pe-btn">Choose File</button>
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>
                                    <label className="add-pdf-label">PDF Only</label>

                                </div>
                            }

                            <div className="child-container">
                                <TextInput id="title" changeHandler={this.handleChange} labelText="Title"
                                    placeholder="Title" inputState="default" value={successObj.title}/>
                            </div>

                            <div className="child-container">
                                {successObj.type && <Select id="type"
                                    labelText="Type"
                                    changeHandler={this.handleChange}
                                    options={[OM3P.ORIGINAL_MATERIAL]}
                                    selectedOption= {successObj.type}
                                />}
                            </div>

                            <div className="child-container">
                                {successObj.contentType && <Select id="content_type"
                                    labelText="Content Type"
                                    changeHandler={this.handleChange}
                                    options={["Textbook"]}
                                    selectedOption= {successObj.contentType}
                                />}
                            </div>

                            <div className="child-container">
                                <TextInput id="firstName" labelText="Author First Name" value={successObj.firstName} changeHandler={this.handleChange}/>
                            </div>

                            <div className="child-container">
                                <TextInput id="lastName" labelText="Author Last Name" value={successObj.lastName} changeHandler={this.handleChange}/>
                            </div>

                            <div className="child-container">
                                <Select id="trimSize"
                                    labelText="Trim Size"
                                    changeHandler={this.handleChange}
                                    options={["6 x 9","8.5 x 11","10 x 8.5"]}
                                    selectedOption= {successObj.trimSize}
                                    inputState={this.props.editModal ? "disabled" : ''}
                                />
                            </div>

                            <div className="child-container">
                                { successObj.resourceColorSetting && <Select id="resourceColorSetting"
                                    labelText="Color"
                                    changeHandler={this.handleChange}
                                    options={["Color","Black and White"]}
                                    selectedOption= {successObj.resourceColorSetting}
                                />}
                            </div>

                            <div className="child-container">

                                <label className="pe-textLabelInput__label" htmlFor="description">Description</label>
                                <textarea id="description" className="pe-multiLineText description" value={successObj.description}
                                    onChange={this.handleChange} ></textarea>

                            </div>

                            {
                                !this.props.editModal && <div className="child-container">
                                    <div className="insert-after-box">
                                        <TextInput id="insertAfter" pattern="^[0-9]*$" labelText="Insert After" value={successObj.insertAfter} changeHandler={this.handleChange}/>
                                    </div>

                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>


        </ModalDialog>;
    }
}

const Om3pModal = (props) => <AuthConsumer>
    {({ userProfile }) => <Om3pModalContainer {...props} userId={userProfile ? userProfile.id : ""} />}
</AuthConsumer>;

export default Om3pModal;


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/OM3PComponents/OmModalContainer.js